<template>
	<div v-loading="loading" class="base_scroll_page">
		<!-- 主体区域 -->
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">用户账号：</span>
					<el-input v-model="search_model" class="b_inp" placeholder="用户账号"></el-input>
				</div>


				<div v-if="authInfo.ucategory == 1 ||authInfo.ucategory == 2 " class="b_item">
					<span class="b_label">机构：</span>
					<el-select v-model="search_oid" class="b_inp" filterable placeholder="请选择" :clearable="true">
						<el-option v-for="v in allOrganization" :key="v.id" :label="v.name" :value="v.id">
						</el-option>
					</el-select>
				</div>
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker v-model="startTime" :editable="false" placeholder="开始时间" type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss" @change="handleSearchStartTimeClick">
					</el-date-picker>
				</div>

				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker v-model="endTime" :editable="false" placeholder="结束时间" type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss" @change="handleSearchEndTimeClick">
					</el-date-picker>
				</div>
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			<div style="margin-top: 20px;font-size: 0;text-align: right;">
				<el-button type="primary" @click="exportExcel">导出数据</el-button>
			</div>
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table :data="tableData" style="width: 100%">
					<!-- <el-table-column prop="machineId" label="机器">
					</el-table-column> -->
					<el-table-column prop="userCode" label="用户账户">
					</el-table-column>

					<el-table-column prop="userName" label="用户名">
					</el-table-column>
					<el-table-column prop="productionSerial" label="设备编号">
					</el-table-column>

					<el-table-column prop="name" label="所属门店">
					</el-table-column>

					<el-table-column prop="runParam" label="设定参数">
						<template slot-scope="scope">
							<div v-html="scope.row.runParam"></div>
						</template>
					</el-table-column>
					<el-table-column prop="createTs" label="开始时间">
					</el-table-column>

					<el-table-column prop="runParam" label="是否正常结束">
						<template slot-scope="scope">
							<div v-if="scope.row.isyn=='是'">√</div>
							<div v-else>x</div>
						</template>
					</el-table-column>


					<!-- <el-table-column prop="isyn" label="是否正常结束">
					</el-table-column> -->

					<el-table-column prop="endTime" label="结束时间">
					</el-table-column>
					<el-table-column prop="treatmentTime" label="理疗时长(分钟)">
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->

			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination layout="total, prev, pager, next, jumper" next-text="下一页" :total="total"
						:current-page="currentPage" @current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>

		<!-- 查看弹框 -->
		<ViewIF :id="view_id" v-model="view_display"></ViewIF>
		<!-- 查看弹框 end -->

		<!-- 修改弹框 -->
		<update v-model="update_display" :id="update_id" @onSuccess="getData"></update>
		<!-- 修改弹框 end -->

		<!-- 充值记录弹框 -->
		<recharge-record v-model="rechargeRecord_display"></recharge-record>
		<!-- 充值记录弹框 end -->

		<!-- 消费记录弹框 -->
		<consume-record v-model="consumeRecord_display" :id="consumeRecord_id"></consume-record>
		<!-- 消费记录弹框 end -->

		<!-- 治疗记录弹框 -->
		<treatment-record v-model="treatmentRecord_display" :id="treatmentRecord_id"></treatment-record>
		<!-- 治疗记录弹框 end -->

		<!-- SIM卡记录弹框 -->
		<sim-record v-model="simRecord_display" :id="simRecord_id"></sim-record>
		<!-- 卡记录弹框 end -->
	</div>
</template>

<script>
	import BaseMethods from '../../../../../assets/js/base.js';
	import ViewIF from './components/view.vue';
	import Update from './components/update.vue';
	import RechargeRecord from '../components/recharge_record.vue';
	import ConsumeRecord from '../components/consume_record.vue';
	import TreatmentRecord from '../components/treatment_record.vue';
	import SimRecord from '../components/sim_record.vue';
	import {
		mapState
	} from 'vuex';
	import Api from '../../../../../api/index.js';

	export default {
		mounted() {
			this.getData();

		},
		data() {
			return {
				loading: false,

				search_model: '',
				search_chipId: '',
				search_startDate: '',
				search_endDate: '',
				search_oid: '',

				tableData: [],
				currentPage: 1,
				total: 0,

				view_display: false,
				view_id: -1,

				update_display: false,
				update_id: -1,

				rechargeRecord_display: false,

				consumeRecord_display: false,
				consumeRecord_id: -1,

				treatmentRecord_display: false,
				treatmentRecord_id: -1,

				simRecord_display: false,
				simRecord_id: -1,

				isn: '',

				startTime: '',
				endTime: ''

			}
		},
		computed: {
			...mapState([
				'allOrganization',
				'authInfo'
			])
		},
		methods: {
			/************************ @Events *******************************/
			// 时间转换
			time(date) {
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? ('0' + m) : m;
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				var h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				var minute = date.getMinutes();
				minute = minute < 10 ? ('0' + minute) : minute;
				var second = date.getSeconds();
				second = second < 10 ? ('0' + second) : second;
				return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
			},

			// 切换查询时间
			handleSearchDateChange() {
				this.compareSearchDate();
			},
			// 点击查询
			handleSearchClick() {
				this.currentPage = 1;
				this.getData();
			},
			// 点击页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getData();
				}
			},
			// 点击查看
			handleViewClick(obj) {
				this.view_id = obj.id;
				this.view_display = true;
			},
			// 点击修改
			handleUpdateClick(obj) {
				this.update_id = obj.id;
				this.update_display = true;
			},
			// 点击充值记录
			handleRechargeRecordClick() {
				this.rechargeRecord_display = true;
			},
			// 点击消费记录
			handleConsumeRecordClick(obj) {
				this.consumeRecord_id = obj.id;
				this.consumeRecord_display = true;
			},
			// 点击治疗记录
			handleTreatmentRecordClick(obj) {
				this.treatmentRecord_id = obj.id;
				this.treatmentRecord_display = true;
			},
			// 点击SIM卡记录
			handleSimRecordClick(obj) {
				this.simRecord_id = obj.id;
				this.simRecord_display = true;
			},

			/************************ @Function *******************************/



			// 导出Excel数据
			exportExcel() {
				const that = this;
				that.loading = true;
				var _requestData = {
					userCode: that.search_model,
					searchEnterpriseId: that.search_oid,
					excel: 1,
					start: that.startTime,
					end: that.endTime
				};
				Api.consumptionpageNew(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						let treatmentTime = '';
						let endTime = '';
						let productionSerial = '';
						let runParam = '';
						let isn = '';
						var str = '用户账户,用户名,设备编号,所属门店,设定参数,开始时间,是否正常结束,结束时间,理疗时长,\n';
						for (var i = 0; i < res.data.data.length; i++) {
							if (res.data.data[i].treatmentTime >= 0) {
								treatmentTime = res.data.data[i].treatmentTime; //理疗时长
								endTime = res.data.data[i].endTime; //结束时间
								isn = '√'
							} else {
								if (res.data.data[i].runParam) {
									// const addedTime = new Date(res.data.data[i].createTs);
									// addedTime.setMinutes(addedTime.getMinutes() + time.time); // 加30分钟
									// endTime = this.time(addedTime)
									let time = JSON.parse(res.data.data[i].runParam)
									treatmentTime = time.time
									isn = 'x'


								} else {
									treatmentTime = ''
								}

							}

							if (res.data.data[i].frequencyDetector) {
								if (res.data.data[i].frequencyDetector.productionSerial) {
									productionSerial = res.data.data[i].frequencyDetector.productionSerial
								} else {
									productionSerial = ''
								}
							} else {
								productionSerial = ''
							}

							if (res.data.data[i].runParam) {
								if (res.data.data[i].runParam == 'runParamjson') {
									runParam = '/'
								} else {
									let jsonRunParam = JSON.parse(res.data.data[i].runParam);
									if (jsonRunParam.mode == 1) {
										runParam = '类型：' + '近视防控 - ' + '设定时间：' + jsonRunParam.time + '分钟'
									} else if (jsonRunParam.mode == 2) {
										runParam = '类型：' + '缓解视疲劳 - ' + '设定时间：' + jsonRunParam.time + '分钟'
									} else if (jsonRunParam.mode == 3) {
										runParam = '类型：' + '弱视保健 - ' + '设定时间：' + jsonRunParam.time + '分钟'
									} else if (jsonRunParam.mode == 4) {
										runParam = '类型：' + '斜视保健 - ' + '设定时间：' + jsonRunParam.time + '分钟'
									} else if (jsonRunParam.mode == 5) {
										runParam = '类型：' + '眼底病保健 - ' + '设定时间：' + jsonRunParam.time + '分钟'
									} else if (jsonRunParam.mode == 6) {
										runParam = '类型：' + '穴位按摩 - ' + '设定时间：' + jsonRunParam.time + '分钟'
									} else {
										runParam = '/'
									}
								}
							} else {
								runParam = '';
							}
							let name = res.data.data[i].enterpriseName || ''
							if (res.data.data[i].ueName) {
								name = res.data.data[i].ueName
							}
							// str += res.data.data[i].machineId || ''; //机器
							// str += ',';
							str += res.data.data[i].userCode || ''; //用户账户
							str += ',';
							str += res.data.data[i].userName || ''; //用户名
							str += ',';
							str += productionSerial; //设备编号
							str += ',';
							// str += res.data.data[i].enterpriseName || ''; //所属门店
							str += name; //所属门店
							str += ',';
							str += runParam; //设定参数
							str += ',';
							str += res.data.data[i].createTs || ''; //开始时间
							str += ',';
							str += isn || ''; //是否正常结束
							str += ',';
							str += endTime || ''; //结束时间
							str += ',';
							str += treatmentTime + '分钟' || ''; //理疗时间
							str += ',';
							str += '\t,';
							str += '\n';
						}
						BaseMethods.outputExcel(str, '使用记录');
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},

			// 切换查询时间
			handleSearchStartTimeClick() {
				this.compareSearchTime();
			},
			// 切换查询时间
			handleSearchEndTimeClick() {
				this.compareSearchTime();
			},
			// 比较开始时间和结束时间
			compareSearchTime() {
				if (this.startTime && this.endTime) {
					let startTimes = new Date(this.startTime).getTime()
					let endTimes = new Date(this.endTime).getTime();
					if (endTimes < startTimes) {
						this.endTime = '';
						this.$message.warning('结束时间不能小于开始时间');
					}
				}
			},

			// 获取列表数据
			getData() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.currentPage,
					pageSize: 10,
					userCode: that.search_model,
					searchEnterpriseId: that.search_oid,
					start: that.startTime,
					end: that.endTime

				};

				Api.consumptionpageNew(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						let list = [];
						let treatmentTime = '';
						let endTime = '';
						let runParam = ''; //设定参数
						let isyn = '';
						res.data.data.records.forEach(v => {
							let jsonRunParam = JSON.parse(v.runParam);
							if (jsonRunParam.mode == 1) {
								runParam = '类型：' + '近视防控' + '<br>' + '设定时间：' + jsonRunParam.time + '分钟'
							} else if (jsonRunParam.mode == 2) {
								runParam = '类型：' + '缓解视疲劳' + '<br>' + '设定时间：' + jsonRunParam.time + '分钟'
							} else if (jsonRunParam.mode == 3) {
								runParam = '类型：' + '弱视保健' + '<br>' + '设定时间：' + jsonRunParam.time + '分钟'
							} else if (jsonRunParam.mode == 4) {
								runParam = '类型：' + '斜视保健' + '<br>' + '设定时间：' + jsonRunParam.time + '分钟'
							} else if (jsonRunParam.mode == 5) {
								runParam = '类型：' + '眼底病保健' + '<br>' + '设定时间：' + jsonRunParam.time + '分钟'
							} else if (jsonRunParam.mode == 6) {
								runParam = '类型：' + '穴位按摩' + '<br>' + '设定时间：' + jsonRunParam.time + '分钟'
							} else {
								runParam = '/'
							}

							if (v.treatmentTime >= 0) {
								treatmentTime = v.treatmentTime; //理疗时长
								endTime = v.endTime; //结束时间
								isyn = '是'

							} else {
								// const addedTime = new Date(v.createTs);
								// addedTime.setMinutes(addedTime.getMinutes() + time.time); // 加30分钟
								// endTime = this.time(addedTime)
								endTime = '/'
								let time = JSON.parse(v.runParam)
								treatmentTime = time.time
								isyn = '否'
							}
							list.push({
								machineId: v.machineId, //机器
								userCode: v.userCode, //用户账户
								name: v.userType == 1 ? v.enterpriseName : v.ueName, ////所属机构
								userName: v.userName, //用户名
								productionSerial: v.frequencyDetector.productionSerial, //设备编号
								runParam: runParam, //设定参数
								createTs: v.createTs, //开始时间
								endTime: endTime, //结束时间
								treatmentTime: treatmentTime + '分钟', //理疗时间
								isyn: isyn, //是否正常结束


							});
						});
						that.tableData = list;
						that.total = res.data.data.total;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 比较开始时间和结束时间
			compareSearchDate() {
				if (this.search_startDate && this.search_endDate) {
					var startDate = new Date(this.search_startDate).getTime(),
						endDate = new Date(this.search_endDate).getTime();
					if (endDate < startDate) {
						this.search_endDate = '';
						this.$message.warning('结束时间不能小于开始时间');
					}
				}
			},
			// 把计费方式转换为文字
			mapBillingFlagToLabel(flag) {
				let result = '';
				switch (flag) {
					case 1:
						result = '无限制';
						break;
					case 2:
						result = '包月';
						break;
					case 3:
						result = '记次';
						break;
					case 4:
						result = '计时';
						break;
				}
				return result;
			}
		},
		components: {
			ViewIF,
			Update,
			RechargeRecord,
			ConsumeRecord,
			TreatmentRecord,
			SimRecord
		}
	}
</script>

<style>
</style>